export default __webpack_public_path__ + "static/media/Foster_App_Oct_2019.06570d8f.pdf";